import api from "@/api";
import { formatBringgStatus } from "@/helper/orderHelperMethods";

const state = () => ({
  bringgOrderResponse: {},
  bringgTrackingLink: "",
  selectedOrderNumber: 0,
  deliveryEta: "",
  localOrderDate: null,
  localOrderTime: null,
  localOrderAddress: "",
});

const actions = {
  async updateBringgOrderResponse({ commit }, orderNumber) {
    let bringgData = await api({
      method: "GET",
      url: `/123/v2/orders/${orderNumber}/delivery_status`,
    });

    commit(
      "orders/UPDATE_ORDERS_STATUS",
      {
        id: orderNumber,
        status: bringgData.info.status,
      },
      { root: true },
    );

    commit("UPDATE_BRINGG_TRACKING_LINK", bringgData.info.tracking_link);
    let currentBringgStep = {};
    if (!bringgData.info) {
      return (currentBringgStep = { orderStep: 0, status: "Unknown" });
    }
    if (bringgData.info.status === 7) {
      currentBringgStep = { orderStep: 1, status: "Canceled by Store" };
    } else {
      currentBringgStep = formatBringgStatus(bringgData.info.delivery_status);
    }
    //}
    commit("UPDATE_BRINGG_ORDER_RESPONSE", currentBringgStep);
  },

  updateCurrentOrderNumber({ commit }, number) {
    commit("UPDATE_CURRENT_ORDER_NUMBER", number);
  },

  setOrderEta({ commit }, eta) {
    commit("UPDATE_BRINGG_ORDER_ETA", eta);
  },

  setLocalOrderDateTime({ commit }, dateTime) {
    const { localDate, time } = dateTime;
    commit("UPDATE_LOCAL_ORDER_DATE_TIME", { localDate, time });
  },

  setLocalOrderAddress({ commit }, address) {
    commit("SET_LOCAL_ORDER_ADDRESS", address);
  },
};

const mutations = {
  UPDATE_BRINGG_ORDER_RESPONSE(state, data) {
    state.bringgOrderResponse = data;
  },
  UPDATE_BRINGG_TRACKING_LINK(state, link) {
    state.bringgTrackingLink = link;
  },
  UPDATE_CURRENT_ORDER_NUMBER(state, number) {
    state.selectedOrderNumber = number;
  },
  UPDATE_BRINGG_ORDER_ETA(state, eta) {
    state.deliveryEta = eta;
  },
  UPDATE_LOCAL_ORDER_DATE_TIME(state, { localDate, time }) {
    state.localOrderDate = localDate;
    state.localOrderTime = time;
  },
  CLEAR(state) {
    state.bringgOrderResponse = {};
    state.bringgTrackingLink = "";
  },
  SET_LOCAL_ORDER_ADDRESS(state, address) {
    state.localOrderAddress = address;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
